<template lang="pug">
  .tree-wrapper.packages-box-wrapper(v-if="tree.length")
    .tree-categories.wrapper-package
      .tree-category-package(v-for="item in tree" v-if="item.active && item.attachments.length")
        Package(:item="item")
</template>

<script type="text/javascript">
import _ from "underscore";
import api from "@/service/api";
import Package from "@/components/Package";
import { mapState } from "vuex";

export default {
  name: "ChildPackage",
  props: ["family"],
  computed: mapState([
    "token",
    "username"
  ]),
  components: {
    Package,
  },
  data() {
    return {
      tree: [],
    };
  },
  async created() {
    const response = await api.treeFiltered(this.token, this.family)
    const data = response.data.tree
    this.tree = _.first(data).children
  },
};
</script>
